import React from 'react';
import ConfigurationFormComponent from './ConfigurationForm';
export default function ValidationForms() {
  return <ConfigurationFormComponent />;
}
